const KEY = "umi-cookie-consent";

export const hasAnalyticsConsent = () => localStorage.getItem(KEY) === "accepted";

export const loadAnalytics = () => {
  if (!window.gtag || !hasAnalyticsConsent()) return;
  window.gtag("consent", "update", { analytics_storage: "granted" });
};

export const trackPageView = (path) => {
  if (window.gtag && hasAnalyticsConsent()) {
    window.gtag("event", "page_view", { page_path: path });
  }
};

export const trackEvent = (name, params = {}) => {
  if (window.gtag && hasAnalyticsConsent()) {
    window.gtag("event", name, params);
  }
};

let contactTrackingInit = false;

export const initContactTracking = () => {
  if (contactTrackingInit) return;
  contactTrackingInit = true;
  document.addEventListener("click", (e) => {
    const tel = e.target.closest && e.target.closest('a[href^="tel:"]');
    if (tel) {
      trackEvent("click_to_call", {
        form_name: "free_consultation",
        page_location: window.location.href,
        link_location: tel.getAttribute("data-testid") || "phone-link",
      });
      return;
    }
    const mail = e.target.closest && e.target.closest('a[href^="mailto:"]');
    if (mail) {
      trackEvent("click_to_email", {
        form_name: "free_consultation",
        page_location: window.location.href,
        link_location: mail.getAttribute("data-testid") || "email-link",
      });
      return;
    }
    const wa = e.target.closest && e.target.closest('a[href*="wa.me"], a[href*="whatsapp.com"]');
    if (wa) {
      trackEvent("click_to_whatsapp", {
        form_name: "free_consultation",
        page_location: window.location.href,
        link_location: wa.getAttribute("data-testid") || "whatsapp-link",
      });
    }
  });
};
